export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7381.f48cd8fe.jpg";